export default __webpack_public_path__ + "static/media/close-cross.a18c8488.svg";